module.exports = __webpack_public_path__ + "media/images/ui__textCrossLight-12c1bc1f3f0fd3beb3834149177d2346.png";